<div
    class="agpr-wireHeader agpr-contextMenu-parent"
    [ngClass]="{'agpr-wireHeader-editable' : editable}"
    (agprClickUnless)="emitClick()"
    *ngIf="wire"
>
    <ul
        role="menu"
        class="agpr-contextMenu top right"
        [attr.aria-label]="'Amplify.wire.header' | localize"
        [attr.aria-describedby]="errorsId"
    >
        <li role="menuitem">
            <agpr-button
                [id]="'header'"
                *ngIf="editable"
                [style]="buttonTypes.contextMenu"
                [icon]="'fa-regular fa-duotone fa-pen'"
                (click)="emitClick()"
                class="agpr-wireHeader-contextMenu-button"
                tooltip="Amplify.wire.header.editHeader"
            ></agpr-button>
        </li>
    </ul>
    <div class="agpr-wireHeader-headline">
        <div *ngIf="wire.headline">
            {{wire.headline}}
        </div>
        <div
            *ngIf="!wire.headline"
            class="agpr-wireHeader-placeholder"
        >
            <ng-container *ngIf="editable">
                {{'Amplify.wire.header.headline.placeholder' | localize}}
            </ng-container>
        </div>
    </div>

    <div class="agpr-wireHeader-subHeadline">
        <div
            *ngIf="wire.subHeadline"
        >
            {{wire.subHeadline}}
        </div>
        <div
            *ngIf="!wire.subHeadline"
            class="agpr-wireHeader-placeholder"
        >
            <ng-container *ngIf="editable">
                {{'Amplify.wire.header.subHeadline.placeholder' | localize}}
            </ng-container>
        </div>
    </div>

    <div class= "agpr-wireHeader-grid">
        <label
            *ngIf="wire.companyName"
            class="agpr-wireHeader-bold agpr-wireHeader-companyName"
        >
            {{wire.companyName}}
        </label>
        <label
            *ngIf="!wire.companyName"
            class="agpr-wireHeader-placeholder"
        >
            <ng-container *ngIf="editable">
                {{'Amplify.wire.header.companyName.placeholder' | localize}}
            </ng-container>
        </label>

        <label
            *ngIf="wire.dateline"
            class="agpr-wireHeader-bold agpr-wireHeader-dateline"
        >
            {{wire.dateline}}
        </label>
        <label
            *ngIf="!wire.dateline"
            class="agpr-wireHeader-placeholder agpr-wireHeader-bold agpr-wireHeader-dateline"
        >
            <ng-container *ngIf="editable">
                {{'Amplify.wire.header.dateline.placeholder' | localize}}
            </ng-container>
        </label>

        <label
            class="agpr-wireHeader-bold"
            *ngIf="this.wire.status === releaseStatus.sent"
        > {{'Amplify.wire.header.sentDate' | localize}}</label>
        <label
            *ngIf="this.wire.status === releaseStatus.sent"
        >
            {{wire.deliverySchedule.getDisplayString(timezone)}}
        </label>
    </div>
</div>
